import { Http } from '@/lib/http';

export class DelinquencyCommentsService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/app/delinquency-comments/';
  }

  /**
   * Created a new delinquency comment
   * @param {Object} data
   * @param {string} data.comment
   * @param {string} data.userId
   * @param {string} [data.type]
   * @param {string} [data.subject]
   * @param {string} [data.collateralId]
   */
  createDelinquencyComment(data) {
    return this.httpClient().post(`${this.endpoint}`, data);
  }

  /**
   * Updates a delinquency comment
   * @param {Object} data
   * @param {string} data.commentId
   * @param {string} data.userId
   * @param {Object} [data.data]
   * @param {string} [data.data.comment]
   * @param {string} [data.data.type]
   * @param {string} [data.data.subject]
   * @param {string} [data.data.collateralId]
   */
  updateDelinquencyComment(data) {
    return this.httpClient().patch(
      `${this.endpoint}${data.commentId}/${data.userId}`,
      data.data
    );
  }

  /**
   * Deletes a delinquency comment
   * @param {Object} data
   * @param {string} data.commentId
   * @param {string} data.userId
   */
  deleteDelinquencyComment(data) {
    return this.httpClient().delete(
      `${this.endpoint}${data.commentId}/${data.userId}`
    );
  }

  /**
   * Find delinquency comment by filter
   * @param {Object} data
   * @param {string} [data.comment]
   * @param {string} [data.userId]
   * @param {string} [data.type]
   * @param {string} [data.subject]
   * @param {string} [data.collateralId]
   */
  findDelinquencyCommentByFilter(data) {
    return this.httpClient().post(`${this.endpoint}filter`, data);
  }
}
